<div
  role="dialog"
  aria-modal="true"
  aria-label="Select airport"
  (keydown.escape)="closeModal()"
  cdkTrapFocus
>
  <div
    class="airport-dropdown__close flex justify-between laptop:hidden bg-surface-navigation h-[64px] w-[100vw] px-[16px] py-[20px]"
  >
    <div class="text-inverse text-label-md-medium">
      {{ content.mobileCloseHeaderText }}
    </div>
    <idp-close-header-button
      (closeHeader)="closeModal()"
    ></idp-close-header-button>
  </div>

  <div
    tabindex="-1"
    class="bg-surface-02 laptop:rounded-03 h-full w-webkit-fill laptop:h-[412px] laptop:w-[435px] border-[1px] border-stroke-01 absolute px-[16px] py-[20px] laptop:px-[55px] laptop:py-[40px] gap-[20px] z-[1050]"
  >
    <button
      (click)="closeModal()"
      aria-label="Close"
      class="absolute right-[15px] top-[20px] hidden laptop:block"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 1.4668L8.95801 8L15.498 14.5332L14.5293 15.5L7.98926 8.96777L1.4707 15.4805L0.50293 14.5137L7.02148 8.00098L0.5 1.48633L1.46875 0.519531L7.99023 7.03418L14.5322 0.5L15.5 1.4668Z"
          fill="#001E3C"
        />
      </svg>
    </button>
    <div
      *ngIf="content.tabOptions"
      class="flex justify-between items-center border-stroke-01 border-b border-solid"
    >
      <div class="flex gap-6">
        <div class="tabs whitespace-nowrap" id="tabs-width-fixed-small"></div>
      </div>
    </div>

    <div class="pt-[20px]">
      <div class="h-[412px] rounded-03">
        <div [id]="content.airportList.id" class="search"></div>
        <div *ngIf="searchErrorMessage" class="mt-2">
          <span class="text-alert text-caption-medium">
            {{ searchErrorMessage }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
